<template>
  <v-container id="cuenta-corriente-jugador">
  <validation-observer v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(validateForm)">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-menu ref="fechaMin" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <validation-provider v-slot="{ errors }" name="fecha desde">
                    <v-text-field v-model="fMin" :error-messages="errors" color="gold" label="Fecha desde" readonly clearable v-on="on" />
                  </validation-provider>
                </template>
                <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419" no-title @input="menu1 = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu ref="fechaMax" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                <template v-slot:activator="{ on }">
                  <validation-provider v-slot="{ errors }" name="fecha hasta">
                    <v-text-field v-model="fMax" :error-messages="errors" color="gold" label="Fecha hasta" readonly clearable v-on="on" />
                  </validation-provider>
                </template>
                <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419" no-title @input="menu2 = false" />
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <validation-provider
                v-slot="{ errors }"
                name="jugador"
                rules="required"
              >
                <v-autocomplete
                  v-model="jugador_id"
                  color="gold"
                  :error-messages="errors"
                  label="Jugador"
                  item-value="id"
                  item-text="fullName"
                  :items="jugadores"
                  clearable
                >
                  <template v-slot:item="{ attrs, item, on }">
                    <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.fullName" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="1" class="mt-1">
              <v-btn fab dark small color="indigo" type="submit">
                <v-icon dark>
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </form>
  </validation-observer>
    <v-row class="px-3">
      <v-expansion-panels v-model="paneles" multiple>
        <v-expansion-panel v-for="(value, key) in monedas" :key="key">
          <template>
            <v-expansion-panel-header v-show="hayDato[key].valor">
              <template slot="default">
                <v-row>
                  <v-col cols="12" class="pa-1">
                    <span :class="totales[key] > 0 ? 'positivo' : 'negativo'"> {{ value.simbolo }} {{ totales[key] }} </span>
                  </v-col>
                  <v-col cols="12" class="pa-1">
                    <span class="titulo"> {{ value.descripcion }} </span>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-show="hayDato[key].valor">
              <resumen-tabla
                :monedaId="value.id"
                :urlparametrizada="urlparametrizada"
                @hayPagos="hayDato[key].valor = $event"
                @total="generarTotal(key, $event)"
              >
              </resumen-tabla>
            </v-expansion-panel-content>
          </template>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import ResumenTabla from './ResumenTabla.vue'
  import Vue from 'vue'

  export default {

    name: 'CuentaCorrienteResumen',
    components: {
      ResumenTabla,
    },

    data () {
      return {
        monedas: [],
        jugadores: [],
        totales: [],
        total: 0,
        menu1: false,
        menu2: false,
        hayDato: [],
        paneles: [],
        fMin: null,
        fMax: null,
        jugador_id: '',
        urlparametrizada: '',
      }
    },

    computed: {

    },

    created () {
      this.getJugadores()
      this.getMoneda()
    },

    methods: {

      getJugadores: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/jugador' }).then(response => { this.jugadores = response })
      },

      getMoneda: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => {
          this.monedas = response
          this.setHayDato()
          this.openPaneles()
        })
      },

      getUrlParametrizada () {
        var url = ''
        if (this.fMin !== null) {
          url += '&fechaDesde=' + this.fMin
        }
        if (this.fMax !== null) {
          url += '&fechaHasta=' + this.fMax
        }
        url += '&jugadorId=' + this.jugador_id

        const urlparametrizada = url
        this.urlparametrizada = urlparametrizada
      },

      generarTotal ($key, $total) {
        Vue.set(this.totales, $key, $total)
      },

      setHayDato () {
        var i
        for (i = 0; i < this.monedas.length; i++) {
          this.hayDato.push({ valor: true })
        }
      },

      openPaneles () {
        this.paneles = []
        for (var i = 0; i < this.monedas.length; i++) {
          this.paneles.push(i)
        }
      },

      validateForm (scope) {
        this.getUrlParametrizada()
        this.openPaneles()
      },

    },
  }
</script>

<style>
  .titulo
  {
    font-size: 14px;
  }
  .positivo
  {
    color:rgb(0, 177, 106) !important;
    font-size: 15px !important;
  }
  .negativo
  {
    color:rgb(240, 52, 52) !important;
    font-size: 15px !important;
  }
</style>
